import { RootState } from '../../store';

export const selectFeatureFlags = (state: RootState) =>
  state.featureFlags.flags;

// Defaults to `true` when the flag is not present in the fetched set
// (fail-open), so an unknown/not-yet-configured flag is treated as enabled.
export const selectIsFeatureFlagEnabled = (
  state: RootState,
  key: string
): boolean => {
  const value = state.featureFlags.flags[key];
  return value === undefined ? true : value === true;
};

// Explicit opt-in: absent / not-yet-loaded flags are treated as OFF. Use this
// (rather than the fail-open selector above) for flags that gate a feature on,
// where the safe default is the pre-existing behaviour.
export const selectIsFeatureFlagExplicitlyEnabled = (
  state: RootState,
  key: string
): boolean => state.featureFlags.flags[key] === true;
